/******************************************************************************
 * DashboardPeriodSelect: today / month / year, using the app's react-select. *
 *****************************************************************************/

import Select from "react-select";
import { useTranslation } from "react-i18next";
import { DASHBOARD_PERIODS, type DashboardPeriod } from "./dashboardPeriod";

interface PeriodOption {
  value: DashboardPeriod;
  label: string;
}

export default function DashboardPeriodSelect({
  value,
  onChange
}: {
  value: DashboardPeriod;
  onChange: (period: DashboardPeriod) => void;
}) {
  const { t } = useTranslation();
  const options: PeriodOption[] = DASHBOARD_PERIODS.map((period) => ({
    value: period,
    label: t(`common:dashboardPeriod.${period}`)
  }));
  const selected = options.find((option) => option.value === value) ?? options[0];

  return (
    <Select<PeriodOption>
      options={options}
      value={selected}
      onChange={(option) => option && onChange(option.value)}
      isClearable={false}
      isSearchable={false}
      className="w-44"
      classNamePrefix="react-select"
      name="dashboardPeriod"
      aria-label={t("common:dashboardPeriod.label")}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "rgb(14 165 233)",
        },
      })}
    />
  );
}
